import { LinkIcon as HeroLinkIcon } from '@heroicons/react/24/outline';
export const LinkIcon = HeroLinkIcon;
